import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Page from '~/components/page/page';
import Lot from '~/containers/lot/lot';

export class LotPage extends Component {
  state = {
    lot: null
  };

  onReceiveLot = ({ lot }) => {
    this.setState({
      lot: lot
    });
  };

  renderTitle = () => {
    const { lot } = this.state;

    return <Fragment>{lot && lot.reference}</Fragment>;
  };

  render() {
    const lotId = this.props.match.params.lotId;
    return (
      <Page>
        <Lot id={lotId} />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(LotPage));



// WEBPACK FOOTER //
// ./src/pages/lot/lot.jsx